module.exports = __webpack_public_path__ + "facc8285b9e4ce52e678188cb7818d9b.svg";